/**
 * [NWF] Re-checks Meterware stock right before checkout (NWF-221).
 *
 * The cart shows the stock it had when it was rendered. Shopify's checkout only compares the line
 * quantity (always 1 for a cut) with the stock, so a cut that has meanwhile become too long would
 * go through. On "Zur Kasse" this re-renders the cart sections together with nwf-cart-stock-check
 * in one request. If the stock no longer suffices, the fresh sections are handed to the theme, so
 * the drawer or cart page shows the hint in place; otherwise checkout continues. Fails open: if
 * the check cannot be made, checkout proceeds.
 */
(function () {
    if (window.__nwfCartCheckoutGuard) {
        return;
    }
    window.__nwfCartCheckoutGuard = true;

    var SECTION = 'nwf-cart-stock-check';
    var MAX_SECTIONS = 5;

    function hasMeterwareLine(form) {
        var scope = form.closest('main-cart, cart-drawer') || document;
        return Boolean(scope.querySelector('.nwf-cart-price'));
    }

    function cartSections() {
        var sections = [];
        document.documentElement.dispatchEvent(
            new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } }),
        );
        return sections
            .filter(function (id, index) {
                return id && sections.indexOf(id) === index && id !== SECTION;
            })
            .slice(0, MAX_SECTIONS - 1);
    }

    function refreshCart() {
        var body = JSON.stringify({
            sections: cartSections().concat(SECTION),
            sections_url: window.location.pathname,
        });
        return fetch(
            FoxTheme.routes.cart_update_url,
            Object.assign({}, FoxTheme.utils.fetchConfig(), { body: body, cache: 'no-store' }),
        )
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('HTTP ' + response.status);
                }
                return response.json();
            })
            .then(function (cart) {
                var html = cart && cart.sections && cart.sections[SECTION];
                if (!Array.isArray(cart.items) || typeof html !== 'string') {
                    throw new Error('unexpected response');
                }
                var marker = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-nwf-over-stock]');
                if (!marker) {
                    throw new Error('marker missing');
                }
                return { cart: cart, overStock: marker.dataset.nwfOverStock === 'true' };
            });
    }

    function proceed(form, submitter) {
        submitter.removeAttribute('aria-busy');
        form.dataset.nwfStockChecked = '1';
        form.requestSubmit(submitter);
    }

    document.addEventListener(
        'submit',
        function (event) {
            var form = event.target;
            var submitter = event.submitter;
            if (!(form instanceof HTMLFormElement) || !submitter || submitter.name !== 'checkout') {
                return;
            }
            if (form.dataset.nwfStockChecked === '1') {
                delete form.dataset.nwfStockChecked;
                return;
            }
            if (!(window.FoxTheme && FoxTheme.routes && FoxTheme.utils && FoxTheme.pubsub)) {
                return;
            }
            if (!hasMeterwareLine(form)) {
                return;
            }

            event.preventDefault();
            event.stopImmediatePropagation();
            if (submitter.getAttribute('aria-busy') === 'true') {
                return;
            }
            submitter.setAttribute('aria-busy', 'true');

            refreshCart()
                .then(function (result) {
                    if (!result.overStock) {
                        proceed(form, submitter);
                        return;
                    }
                    submitter.removeAttribute('aria-busy');
                    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: result.cart });
                })
                .catch(function (error) {
                    if (window.console) {
                        console.warn('[nwf-cart-checkout-guard] stock check failed, continuing', error);
                    }
                    proceed(form, submitter);
                });
        },
        true,
    );
})();
